import { Affix, Button, Card, Spin } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getData, postData } from "../../../apiServices/common";
import { isMobileView } from "../../Common/AppHelper";
import Header from "../../Common/Header";
import AddPurchaseOrderForm from "./AddPurchaseOrderForm";

export default function UpdateUnitsPrice(props) {
  // Props
  const { width, isAddPrice = false } = props;
  const navigate = useNavigate();

  // States
  const [permitInfo, setPermitInfo] = useState();
  const [poDetailsData, setPoDetailsData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Others
  const { styleId } = useParams();
  const propertyFormRef = useRef(null);
  const edit_url = `/api/purchase_orders/${styleId}/edit`;

  const discartForm = () => {
    navigate("/merchandising/style-wise-quantity-breakdown");
  };

  const addProduct = () => {
    if (isSubmitting) return;
    propertyFormRef.current.submit();
  };

  // const getPOInfo = useCallback(async () => {
  //   let res = await getData(edit_url);

  //   if (res) {
  //     let masterData = res.data.data;
  //     setPermitInfo(masterData);
  //     const po_data = masterData ? masterData.purchase_order_details : null;

  //     const po_details = po_data.map((item) => {
  //       const sizes = {};

  //       item?.sizes.forEach((size) => {
  //         sizes[size?.name + "_" + size?.id] = isAddPrice
  //           ? size?.order_price || 0
  //           : size?.sales_order_quantity;
  //       });
  //       return {
  //         ...item,
  //         style_id: item.style.id,
  //         color_id: item.color.id,
  //         ...sizes,
  //       };
  //     });

  //     setPoDetailsData(po_details);
  //   }
  // }, [edit_url]);

  const getPOInfo = useCallback(
    async (styleIds = null) => {
      // const query = `/api/unit_prices/${itemId}/edit`;
      const payload = {};
      if (styleIds && styleIds.length > 0) {
        payload.style_ids = styleIds;
      }

      // if (type) {
      //   payload.type = type;
      // }
      let res = await postData(edit_url, payload);

      if (res) {
        let masterData = res.data;
        setPermitInfo(masterData);
        const po_data = masterData ? masterData?.purchase_order_details : null;

        const po_details = po_data?.map((item) => {
          const sizes = {};

          item?.sizes.forEach((size) => {
            sizes[size?.name + "_" + size?.id] = size?.sales_order_quantity;
          });
          return {
            ...item,
            style_id: item.style.id,
            color_id: item.color.id,
            ...sizes,
          };
        });

        setPoDetailsData(po_details);
      }
      setIsLoading(false);
    },
    [edit_url],
  );

  useEffect(() => {
    // Only run on first render
    // DO NOT add any depenedency here
    getPOInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title={isAddPrice ? "Add Style Wise Quantity Breakdown" : "Update Style Wise Quantity Breakdown"}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()} disabled={isSubmitting}>
                Back
              </Button>,
              <Button
                size="small"
                key={2}
                type="primary"
                loading={isSubmitting}
                disabled={isSubmitting}
                onClick={() => addProduct()}
              >
                {isAddPrice ? "Add Price For Purchase Order" : "Update Purchase Order"}
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <Spin spinning={isLoading} tip="Loading...">
        <AddPurchaseOrderForm
          ref={propertyFormRef}
          permitInfo={permitInfo}
          poDetailsData={poDetailsData}
          setPoDetailsData={setPoDetailsData}
          mode="update"
          isAddPrice={isAddPrice}
          getPOInfo={getPOInfo}
          isSubmitting={isSubmitting}
          setIsSubmitting={setIsSubmitting}
        />
      </Spin>
    </>
  );
}
